import NFilteredSitePlansToShow from '../enums/NFilteredSitePlansToShow';
import ParameterErrors from '../errors/ParameterErrors';
import PlotStatusConfigurations from './PlotStatusConfigurations';
import CurrencyConfiguration from './CurrencyConfiguration';
const {throwNotProvided}=ParameterErrors;
export default class Configuration{
	constructor(props){
		const {plotStatusConfigurations, goStraightToFiltersMenu, showShowForSaleButton,
			hidePlotMoreInformationTabs, plotMoreInformationHasOverview,
			fullScreenGalleryAndFloorPlans, useCurrentPositionIcon,  sentryDSN, brochureGeneratorUrl,
			delayShowPlotMarkersSeconds, plotMarkerKeyAtTop, googleAnalyticsTrackingCode,
			siteName, siteSlug, siteSlugForLatestSiteInfo, assetsFolderName, configuratorRootUrl, siteInfoUrl, defaultOutside360PlotNumber,
			defaultAerialIndex, threeDEnabled, windowStyleMenus, showNBathrooms,
			showPlotDetailedInformationOnDesktopClickInsteadOfHover, brochuresMenuEnabled,
			plotComparisonEnabled, onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo,
			showHouseTypesViewerOnOpen, siteVideoEnabled, showFadedFilteredOutPlots,
			twoDSitePlanEnabled, miniMapConeMarkerEnabled, showPanelOnClickOutside360ConfiguratorIcon,
			whatAreYouLookingForEnabled, featuresEnabled, nFilteredSitePlansToShow, suggestedSitesEnabled,
			houseTypesViewerEnabled, hideNBedrooms, rotateOutside360Cameras180Degrees,
			showPlotDetailedInformationOnClickPlotMenu, plotSelectionMenuEnabled} = props;	
		if(plotStatusConfigurations===undefined||plotStatusConfigurations===null)
			throwNotProvided('plotStatusConfigurations');
		this._hideNBedrooms = hideNBedrooms;
		this._plotStatusConfigurations = plotStatusConfigurations;
		this._goStraightToFiltersMenu= goStraightToFiltersMenu;
		this._showShowForSaleButton= showShowForSaleButton;
		this._hidePlotMoreInformationTabs = hidePlotMoreInformationTabs;
		this._plotMoreInformationHasOverview = plotMoreInformationHasOverview;
		this._fullScreenGalleryAndFloorPlans = fullScreenGalleryAndFloorPlans;
		this._useCurrentPositionIcon = useCurrentPositionIcon;
		this._sentryDSN = sentryDSN;
		this._brochureGeneratorUrl = brochureGeneratorUrl;
		this._delayShowPlotMarkersSeconds= delayShowPlotMarkersSeconds;
		this._plotMarkerKeyAtTop = plotMarkerKeyAtTop;
		this._googleAnalyticsTrackingCode=googleAnalyticsTrackingCode;
		this._siteSlug = siteSlug;
		this._siteSlugForLatestSiteInfo = siteSlugForLatestSiteInfo;
		this._configuratorRootUrl = configuratorRootUrl;
		this._siteInfoUrl = siteInfoUrl
		this._defaultOutside360PlotNumber = defaultOutside360PlotNumber;
		this._defaultAerialIndex = defaultAerialIndex;
		this._threeDEnabled = threeDEnabled;
		this._windowStyleMenus = windowStyleMenus;
		this._siteName= siteName;
		this._showNBathrooms= showNBathrooms;
		this._showPlotDetailedInformationOnDesktopClickInsteadOfHover = showPlotDetailedInformationOnDesktopClickInsteadOfHover; 
		this._brochuresMenuEnabled = brochuresMenuEnabled;
		this._plotComparisonEnabled = plotComparisonEnabled;
		this._onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo = onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo;
		this._showHouseTypesViewerOnOpen = showHouseTypesViewerOnOpen;
		this._siteVideoEnabled = siteVideoEnabled;
		this._showFadedFilteredOutPlots = showFadedFilteredOutPlots;
		this._twoDSitePlanEnabled=twoDSitePlanEnabled;
		this._miniMapConeMarkerEnabled = miniMapConeMarkerEnabled;
		this._showPanelOnClickOutside360ConfiguratorIcon = showPanelOnClickOutside360ConfiguratorIcon;
		this._whatAreYouLookingForEnabled= whatAreYouLookingForEnabled;
		this._featuresEnabled = featuresEnabled;
		this._houseTypesViewerEnabled = houseTypesViewerEnabled;
		this._nFilteredSitePlansToShow = 
		nFilteredSitePlansToShow===1
		?NFilteredSitePlansToShow.One
		:(
			nFilteredSitePlansToShow===2?NFilteredSitePlansToShow.Two:NFilteredSitePlansToShow.All
		);
		this._suggestedSitesEnabled = suggestedSitesEnabled;
		this._rotateOutside360Cameras180Degrees = rotateOutside360Cameras180Degrees;
		this._showPlotDetailedInformationOnClickPlotMenu=showPlotDetailedInformationOnClickPlotMenu===undefined||showPlotDetailedInformationOnClickPlotMenu;
		this._plotSelectionMenuEnabled=plotSelectionMenuEnabled===undefined||plotSelectionMenuEnabled;
		//0 all, 1:1, 2:two side by side. >2: same as 0, null or undefined: same as
	}
	get plotSelectionMenuEnabled(){
		return this._plotSelectionMenuEnabled;
	}
	get showPlotDetailedInformationOnClickPlotMenu(){
		return this._showPlotDetailedInformationOnClickPlotMenu;
	}
	get houseTypesViewerEnabled(){
		return this._houseTypesViewerEnabled;
	}
	get suggestedSitesEnabled(){
		return this._suggestedSitesEnabled;
	}
	get nFilteredSitePlansToShow(){
		return this._nFilteredSitePlansToShow;
	}
	get featuresEnabled(){
		return this._featuresEnabled;
	}
	get whatAreYouLookingForEnabled(){
		return this._whatAreYouLookingForEnabled||window.location.href.split('#')[1]==='welcome';
	}
	get showPanelOnClickOutside360ConfiguratorIcon(){
		return this._showPanelOnClickOutside360ConfiguratorIcon;
	}
	get miniMapConeMarkerEnabled(){
		return this._miniMapConeMarkerEnabled;
	}
	get showFadedFilteredOutPlots(){
		return this._showFadedFilteredOutPlots;
	}
	get showHouseTypesViewerOnOpen(){
		return this._showHouseTypesViewerOnOpen;
	}
	get plotComparisonEnabled(){
		return this._plotComparisonEnabled;
	}
	get brochuresMenuEnabled(){
		return this._brochuresMenuEnabled;
	}
	get showPlotDetailedInformationOnDesktopClickInsteadOfHover(){
		return this._showPlotDetailedInformationOnDesktopClickInsteadOfHover;
	}
	get windowStyleMenus(){
		return this._windowStyleMenus;
	}
	get showNBathrooms(){
		return this._showNBathrooms;
	}
	get threeDEnabled(){
		return this._threeDEnabled;
	}
	get siteName(){
		return this._siteName;
	}
	get siteSlug(){
		return this._siteSlug;
	}
	get siteSlugForLatestSiteInfo(){
			return this._siteSlugForLatestSiteInfo;
		
	}
	get defaultOutside360PlotNumber(){
		return this._defaultOutside360PlotNumber;
	}
	get defaultAerialIndex(){
		return this._defaultAerialIndex;
	}
	get plotStatusConfigurations(){
		return this._plotStatusConfigurations;
	}
	get currencyConfiguration(){
		return this._currencyConfiguration;
	}
	get goStraightToFiltersMenu(){
		return this._goStraightToFiltersMenu;
	}
	get showShowForSaleButton(){
		return this._showShowForSaleButton;
	}
	get hidePlotMoreInformationTabs(){
		return this._hidePlotMoreInformationTabs;
	}
	get plotMoreInformationHasOverview(){
		return this._plotMoreInformationHasOverview ;
	}
	get scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages(){
		return this._scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages;
	}
	get fullScreenGalleryAndFloorPlans(){
		return this._fullScreenGalleryAndFloorPlans;
	}
	get useCurrentPositionIcon(){
		return this._useCurrentPositionIcon;
	}
	get sentryDSN(){
		return this._sentryDSN;
	}
	get brochureGeneratorUrl(){
		return this._brochureGeneratorUrl;
	}
	get delayShowPlotMarkersSeconds(){
		return this._delayShowPlotMarkersSeconds;
	}
	get plotMarkerKeyAtTop(){
		return this._plotMarkerKeyAtTop;
	}
	get googleAnalyticsTrackingCode(){
		return this._googleAnalyticsTrackingCode;
	}
	get configuratorRootUrl(){
		return this._configuratorRootUrl;
	}
	get siteInfoUrl(){
		return this._siteInfoUrl;
	}
	get onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo(){
		return this._onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo;
	}
	get siteVideoEnabled(){
		return this._siteVideoEnabled;
	}
	get twoDSitePlanEnabled(){
		return this._twoDSitePlanEnabled;
	}
	get hideNBedrooms(){
		return this._hideNBedrooms;
	}
	get rotateOutside360Cameras180Degrees(){
		return this._rotateOutside360Cameras180Degrees;
	}
	static fromJSON(jObject){
		const plotStatusConfigurations = PlotStatusConfigurations.fromJSON(jObject.plotStatuses);
		return new Configuration({plotStatusConfigurations:plotStatusConfigurations, 
			goStraightToFiltersMenu:jObject.goStraightToFiltersMenu, showShowForSaleButton:jObject.showShowForSaleButton,
			hidePlotMoreInformationTabs:jObject.hidePlotMoreInformationTabs,
			plotMoreInformationHasOverview:jObject.plotMoreInformationHasOverview,
			scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages:
				jObject.scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages,
			fullScreenGalleryAndFloorPlans:jObject.fullScreenGalleryAndFloorPlans,
			useCurrentPositionIcon:jObject.useCurrentPositionIcon,
			sentryDSN:jObject.sentryDSN,
			brochureGeneratorUrl:jObject.brochureGeneratorUrl,
			delayShowPlotMarkersSeconds:jObject.delayShowPlotMarkersSeconds,
			plotMarkerKeyAtTop:jObject.plotMarkerKeyAtTop,
			googleAnalyticsTrackingCode:jObject.googleAnalyticsTrackingCode,
			siteName:jObject.siteName,
			siteSlug:jObject.siteSlug,
			siteSlugForLatestSiteInfo:jObject.siteSlugForLatestSiteInfo,
			configuratorRootUrl:jObject.configuratorRootUrl,
			siteInfoUrl:jObject.siteInfoUrl,
			defaultOutside360PlotNumber:jObject.defaultOutside360PlotNumber,
			defaultAerialIndex:jObject.defaultAerialIndex,
			threeDEnabled:jObject.threeDEnabled,
			windowStyleMenus:jObject.windowStyleMenus,
			brochuresMenuEnabled:jObject.brochuresMenuEnabled,
			showNBathrooms:jObject.showNBathrooms,
			showPlotDetailedInformationOnDesktopClickInsteadOfHover:jObject.showPlotDetailedInformationOnDesktopClickInsteadOfHover,
			plotComparisonEnabled:jObject.plotComparisonEnabled,
			onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo:jObject.onClickPlotSelectionMenuEntryShowDetailedElseSmallPlotInfo,
			showHouseTypesViewerOnOpen:jObject.showHouseTypesViewerOnOpen,
			siteVideoEnabled:jObject.siteVideoEnabled,
			showFadedFilteredOutPlots:jObject.showFadedFilteredOutPlots,
			twoDSitePlanEnabled:jObject.twoDSitePlanEnabled,
			twoDSitePlanEnabled:jObject.twoDSitePlanEnabled,
			miniMapConeMarkerEnabled:jObject.miniMapConeMarkerEnabled,
			showPanelOnClickOutside360ConfiguratorIcon:jObject.showPanelOnClickOutside360ConfiguratorIcon,
			whatAreYouLookingForEnabled:jObject.whatAreYouLookingForEnabled,
			featuresEnabled:jObject.featuresEnabled,
			nFilteredSitePlansToShow:jObject.nFilteredSitePlansToShow,
			suggestedSitesEnabled:jObject.suggestedSitesEnabled,
			houseTypesViewerEnabled:jObject.houseTypesViewerEnabled,
			hideNBedrooms:jObject.hideNBedrooms,
			rotateOutside360Cameras180Degrees:jObject.rotateOutside360Cameras180Degrees,
			showPlotDetailedInformationOnClickPlotMenu:jObject.showPlotDetailedInformationOnClickPlotMenu,
			plotSelectionMenuEnabled:jObject.plotSelectionMenuEnabled
		});
	}
}